// packages/shared-assets/src/index.ts
// 静态资源统一走 /shared-assets/ URL，构建期只拷贝一份，禁止 webpack 打进各子应用。
// 放图规范见同包 ASSETS.md

import { sharedAssetUrl } from "./assetUrl";

export { sharedAssetUrl, SHARED_ASSETS_PUBLIC_PATH } from "./assetUrl";

// Export keyboard images
export const keyboard1 = sharedAssetUrl("keyboard/keyboard1.png");
export const keyboardX87heBlackpink = sharedAssetUrl(
  "keyboard/x87he/x87he-blackpink.avif"
);
export const keyboardX87heBlue = sharedAssetUrl(
  "keyboard/x87he/x87he-blue.avif"
);
export const keyboardX87heDuantan = sharedAssetUrl(
  "keyboard/x87he/x87he-duantan.avif"
);
export const keyboardX87heWhite = sharedAssetUrl(
  "keyboard/x87he/x87he-white.avif"
);
export const keyboardSmart875Black = sharedAssetUrl(
  "keyboard/smart875/smart875-black.avif"
);
export const keyboardSmart875Red = sharedAssetUrl(
  "keyboard/smart875/smart875-red.avif"
);
export const keyboardSmart875Silvery = sharedAssetUrl(
  "keyboard/smart875/smart875-silvery.avif"
);
export const keyboardDk68Black = sharedAssetUrl(
  "keyboard/dk68/dk68-black.avif"
);
export const keyboardDk68White = sharedAssetUrl(
  "keyboard/dk68/dk68-white.avif"
);
export const keyboardDk68Berryred = sharedAssetUrl(
  "keyboard/dk68/dk68-berryred.avif"
);
export const keyboardDk68StarBlack = sharedAssetUrl(
  "keyboard/dk68star/dk68-black.avif"
);
export const keyboardDk68StarWhite = sharedAssetUrl(
  "keyboard/dk68star/dk68-white.avif"
);
export const keyboardDk68StarBerryred = sharedAssetUrl(
  "keyboard/dk68star/dk68-berryred.avif"
);
export const keyboardDk68StarZheying = sharedAssetUrl(
  "keyboard/dk68star/dk68-zheying.avif"
);
export const keyboardDk68V2Foggyblack = sharedAssetUrl(
  "keyboard/dk68v2/dk68v2-foggyblack.avif"
);
export const keyboardDk68V2Foggywhite = sharedAssetUrl(
  "keyboard/dk68v2/dk68v2-foggywhite.avif"
);
export const keyboardDk68V2Foggypink = sharedAssetUrl(
  "keyboard/dk68v2/dk68v2-foggypink.avif"
);
export const keyboardDk68V2White = sharedAssetUrl(
  "keyboard/dk68v2/dk68v2-white.avif"
);
export const keyboardDk68ProBlack = sharedAssetUrl(
  "keyboard/dk68pro/dk68pro-black.avif"
);
export const keyboardDk68ProWhite = sharedAssetUrl(
  "keyboard/dk68pro/dk68pro-white.avif"
);
export const keyboardDk68ProBerryred = sharedAssetUrl(
  "keyboard/dk68pro/dk68pro-berryred.avif"
);
export const keyboardEweadnDk68ProBlack = sharedAssetUrl(
  "keyboard/eweadndk68pro/eweadndk68pro-black.avif"
);
export const keyboardEweadnDk68ProWhite = sharedAssetUrl(
  "keyboard/eweadndk68pro/eweadndk68pro-white.avif"
);
export const keyboardEweadnDk68ProBerryred = sharedAssetUrl(
  "keyboard/eweadndk68pro/eweadndk68pro-berryred.avif"
);
export const keyboardDk63Black = sharedAssetUrl(
  "keyboard/dk63/dk63-black.avif"
);
export const keyboardDk63White = sharedAssetUrl(
  "keyboard/dk63/dk63-white.avif"
);
export const keyboardDk63Berryred = sharedAssetUrl(
  "keyboard/dk63/dk63-berryred.avif"
);
export const keyboardDk63V2WhiteSidePrinted = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-whiteSidePrinted.avif"
);
export const keyboardDk63V2WhiteMistSheer = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-whiteMistSheer.avif"
);
export const keyboardDk63V2WhiteCarbonPattern = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-whiteCarbonPattern.avif"
);
export const keyboardDk63V2ContourLine = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-contourLine.avif"
);
export const keyboardDk63V2PinkSidePrinted = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-pinkSidePrinted.avif"
);
export const keyboardDk63V2BlackSidePrinted = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-blackSidePrinted.avif"
);
export const keyboardDk63V2BlackFrontPrinted = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-blackFrontPrinted.avif"
);
export const keyboardDk63V2BlackCarbonPattern = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-blackCarbonPattern.avif"
);
export const keyboardDk63V2FoldingShadow = sharedAssetUrl(
  "keyboard/dk63v2/DK63V2-foldingShadow.avif"
);
export const keyboardEs98Blackpurple = sharedAssetUrl(
  "keyboard/es98/es98-blackpurple.avif"
);
export const keyboardEs98Tengwangge = sharedAssetUrl(
  "keyboard/es98/es98-tengwangge.avif"
);
export const keyboardEs98Whiteblue = sharedAssetUrl(
  "keyboard/es98/es98-whiteblue.avif"
);
export const keyboardEs98Whitepink = sharedAssetUrl(
  "keyboard/es98/es98-whitepink.avif"
);
export const keyboardX87Baifenjianbian = sharedAssetUrl(
  "keyboard/x87/x87-baifenjianbian.avif"
);
export const keyboardX87Duantan = sharedAssetUrl(
  "keyboard/x87/x87-duantan.avif"
);
export const keyboardX87Fushihui = sharedAssetUrl(
  "keyboard/x87/x87-fushihui.avif"
);
export const keyboardX87Jingmihaiyang = sharedAssetUrl(
  "keyboard/x87/x87-jingmihaiyang.avif"
);
export const keyboardX87Piwen = sharedAssetUrl("keyboard/x87/x87-piwen.avif");
export const keyboardX87Piwenbai = sharedAssetUrl(
  "keyboard/x87/x87-piwenbai.avif"
);
export const keyboardX87Qingti = sharedAssetUrl("keyboard/x87/x87-qingti.avif");
export const keyboardX87Tianxinfen = sharedAssetUrl(
  "keyboard/x87/x87-tianxinfen.avif"
);
export const keyboardX87Weichen = sharedAssetUrl(
  "keyboard/x87/x87-weichen.avif"
);
export const keyboardX87Wutou = sharedAssetUrl("keyboard/x87/x87-wutou.avif");
export const keyboardX87Xueshanjianbian = sharedAssetUrl(
  "keyboard/x87/x87-xueshanjianbian.avif"
);
export const keyboardX87Zheying = sharedAssetUrl(
  "keyboard/x87/x87-zheying.avif"
);
export const keyboardX87Blackpink = sharedAssetUrl(
  "keyboard/x87/x87-blackpink.avif"
);
export const keyboardx87FlameRed = sharedAssetUrl(
  "keyboard/x87/x87-chiyanhong.avif"
);
export const keyboardX87White = sharedAssetUrl("keyboard/x87/x87-white.avif");
export const keyboardX98Purple = sharedAssetUrl("keyboard/x98/x98-purple.avif");
export const keyboardX98Taofen = sharedAssetUrl("keyboard/x98/x98-taofen.avif");
export const keyboardX98Yunjianlan = sharedAssetUrl(
  "keyboard/x98/x98-yunjianlan.avif"
);
export const keyboardX98Zheyingzhiguang = sharedAssetUrl(
  "keyboard/x98/x98-zheyingzhiguang.avif"
);
export const keyboardX75ProWhite = sharedAssetUrl(
  "keyboard/x75pro/x75pro-white.avif"
);
export const keyboardX75ProBlackpink = sharedAssetUrl(
  "keyboard/x75pro/x75pro-blackpink.avif"
);
export const keyboardX75ProGrapePurple = sharedAssetUrl(
  "keyboard/x75pro/x75pro-grapepurple.avif"
);
export const keyboardX75ProJiangGuoHong = sharedAssetUrl(
  "keyboard/x75pro/x75pro-jiangguohong.avif"
);
export const keyboardX75ProMoYingJianBianDengGaoXian3 = sharedAssetUrl(
  "keyboard/x75pro/x75pro-moyingjianbiandenggaoxian3.avif"
);
export const keyboardX75ProPinkGradient = sharedAssetUrl(
  "keyboard/x75pro/x75pro-pinkgradient.avif"
);
export const keyboardX75ProWhiteDengGaoXian3 = sharedAssetUrl(
  "keyboard/x75pro/x75pro-whitedenggaoxian3.avif"
);
export const keyboardX75ProRussiablack = sharedAssetUrl(
  "keyboard/x75pro/x75pro-russiablack.avif"
);
export const keyboardM98FenDiYe = sharedAssetUrl(
  "keyboard/m98/m98-fendiye.avif"
);
export const keyboardM98LeiTaoCiJianMao = sharedAssetUrl(
  "keyboard/m98/m98-leitaocijianmao.avif"
);
export const keyboardX75V2ProWhite = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-white.avif"
);
export const keyboardX75V2ProBlackpink = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-blackpink.avif"
);
export const keyboardX75V2ProGrapePurple = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-grapepurple.avif"
);
export const keyboardX75V2ProJiangGuoHong = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-jiangguohong.avif"
);
export const keyboardX75V2ProMoYingJianBianDengGaoXian3 = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-moyingjianbiandenggaoxian3.avif"
);
export const keyboardX75V2ProPinkGradient = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-pinkgradient.avif"
);
export const keyboardX75V2ProWhiteDengGaoXian3 = sharedAssetUrl(
  "keyboard/x75v2pro/x75v2pro-whitedenggaoxian3.avif"
);
export const keyboardX75V2Whiteblue = sharedAssetUrl(
  "keyboard/x75v2/x75v2-whiteblue.avif"
);
export const keyboardX75V2Blackyellow = sharedAssetUrl(
  "keyboard/x75v2/x75v2-blackyellow.avif"
);
export const keyboardX75V2Zheying = sharedAssetUrl(
  "keyboard/x75v2/x75v2-zheying.avif"
);
export const keyboardX75V2Russianwhiteblue = sharedAssetUrl(
  "keyboard/x75v2/x75v2-russianwhiteblue.avif"
);
export const keyboardX75V2Russianweichen = sharedAssetUrl(
  "keyboard/x75v2/x75v2-russianweichen.avif"
);
export const keyboardX75GcSilverscreen = sharedAssetUrl(
  "keyboard/x75gc/x75gc-silverscreen.avif"
);
export const keyboardX75V3Black = sharedAssetUrl(
  "keyboard/x75v3/x75v3-black.avif"
);
export const keyboardX75V3Silver = sharedAssetUrl(
  "keyboard/x75v3/x75v3-silver.avif"
);
export const keyboardX75UltraBlack = sharedAssetUrl(
  "keyboard/x75ultra/x75ultra-black.avif"
);
export const keyboardX75UltraSilver = sharedAssetUrl(
  "keyboard/x75ultra/x75ultra-silver.avif"
);
export const keyboardExxGamma75Pink = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-pink.avif"
);
export const keyboardExxGamma75Silver = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-silver.avif"
);
export const keyboardExxGamma75Black1 = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-black1.avif"
);
export const keyboardExxGamma75Silver1 = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-silver1.avif"
);
export const keyboardExxGamma75FeatherRed = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-featherRed.avif"
);
export const keyboardExxGamma75FeatherGreen = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-featherGreen.avif"
);
export const keyboardExxGamma75FeatherPurple = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-featherPurple.avif"
);
export const keyboardExxGamma75FeatherBlack = sharedAssetUrl(
  "keyboard/Gamma75/exxGamma75-featherBlack.avif"
);
export const keyboardExxGamma75proBlack = sharedAssetUrl(
  "keyboard/gamma75pro/exxGamma75pro-black.avif"
);
export const keyboardExxGamma75proGreen = sharedAssetUrl(
  "keyboard/gamma75pro/exxGamma75pro-green.avif"
);
export const keyboardExxGamma75proPurple = sharedAssetUrl(
  "keyboard/gamma75pro/exxGamma75pro-purple.avif"
);
export const keyboardExxGamma75proRed = sharedAssetUrl(
  "keyboard/gamma75pro/exxGamma75pro-red.avif"
);
export const keyboardExxGamma75proSilverTwoTone = sharedAssetUrl(
  "keyboard/gamma75pro/exxGamma75pro-silverTwo-tone.avif"
);
export const keyboardExxGamma75proSilvery = sharedAssetUrl(
  "keyboard/gamma75pro/exxGamma75pro-silvery.avif"
);
export const keyboardExxGamma75proEvoKnifeBlackFog = sharedAssetUrl(
  "keyboard/gamma75proEvo/exxGamma75proEvo-knifePattern-blackFogTransparency.avif"
);
export const keyboardExxGamma75proEvoKnifeBlackThreePiece = sharedAssetUrl(
  "keyboard/gamma75proEvo/exxGamma75proEvo-knifePattern-blackThreePiece.avif"
);
export const keyboardExxGamma75proEvoKnifeGreen = sharedAssetUrl(
  "keyboard/gamma75proEvo/exxGamma75proEvo-knifePattern-green.avif"
);
export const keyboardExxGamma75proEvoKnifeSilverSidePrinted = sharedAssetUrl(
  "keyboard/gamma75proEvo/exxGamma75proEvo-knifePattern-silverSidePrinted.avif"
);
export const keyboardExxGamma75proEvoKnifeSilverTwoTone = sharedAssetUrl(
  "keyboard/gamma75proEvo/exxGamma75proEvo-knifePattern-silverTwo-tone.avif"
);
export const keyboardExxGamma75ultraSilvery = sharedAssetUrl(
  "keyboard/gamma75ultra/exxGamma75ultra-silvery.avif"
);
export const keyboardES68EVOPink = sharedAssetUrl(
  "keyboard/es68evo/es68evo-pink.avif"
);
export const keyboardES68EVOBlack = sharedAssetUrl(
  "keyboard/es68evo/es68evo-black.avif"
);
export const keyboardES68EVOSilver = sharedAssetUrl(
  "keyboard/es68evo/es68evo-silver.avif"
);
export const keyboardES68LiteBlack = sharedAssetUrl(
  "keyboard/es68lite/es68lite-black.avif"
);
export const keyboardES68LiteSilver = sharedAssetUrl(
  "keyboard/es68lite/es68lite-silver.avif"
);
export const keyboardAlpha87Silver = sharedAssetUrl(
  "keyboard/alpha87/alpha87-silver.avif"
);
export const keyboardM75Pink = sharedAssetUrl("keyboard/m75/M75-pink.avif");
export const keyboardM75Green = sharedAssetUrl("keyboard/m75/M75-green.avif");
export const keyboardM75Purple = sharedAssetUrl("keyboard/m75/M75-purple.avif");
export const keyboardM75Cat = sharedAssetUrl("keyboard/m75/M75-cat.avif");
// Export axis mode images（按 BRAND 构建期切换 AXIS_MODE_ASSET_PREFIX）
export {
  keyAxisImage01,
  keyAxisImage02,
  keyAxisImage03,
} from "./keyboard/axisMode";

// Export mouse images
export const mouse1 = sharedAssetUrl("mouse/mouse1.png");
export const mouseBlack = sharedAssetUrl("mouse/Z7/Z7-black.avif");
export const mouseSilvery = sharedAssetUrl("mouse/Z7/Z7-silvery.avif");
export const mouseRed = sharedAssetUrl("mouse/Z7/Z7-red.avif");
export const mousePurple = sharedAssetUrl("mouse/Z7/Z7-purple.avif");
export const mouseZ7MasterPinegreen = sharedAssetUrl(
  "mouse/Z7Master/Z7Master-pinegreen.avif"
);
export const mouseZ7MasterBlack = sharedAssetUrl(
  "mouse/Z7Master/Z7Master-black.avif"
);
export const mouseZ7MasterSilver = sharedAssetUrl(
  "mouse/Z7Master/Z7Master-silver.avif"
);
export const mouseZ7MasterRed = sharedAssetUrl(
  "mouse/Z7Master/Z7Master-red.avif"
);
export const mouseS9UltraV2White = sharedAssetUrl(
  "mouse/S9Ultra-V2/S9Ultra-V2-white.avif"
);
export const mouseS9UltraV2Red = sharedAssetUrl(
  "mouse/S9Ultra-V2/S9Ultra-V2-red.avif"
);
export const mouseS9UltraV2LightPurple = sharedAssetUrl(
  "mouse/S9Ultra-V2/S9Ultra-V2-lightpurple.avif"
);
export const mouseS9UltraV2Silver = sharedAssetUrl(
  "mouse/S9Ultra-V2/S9Ultra-V2-silver.avif"
);
export const mouseS9ProV2Black = sharedAssetUrl(
  "mouse/S9Pro-V2/S9Pro-V2-black.avif"
);
export const mouseS9ProV2White = sharedAssetUrl(
  "mouse/S9Pro-V2/S9Pro-V2-white.avif"
);
export const mouseS9ProV2Luotianyi = sharedAssetUrl(
  "mouse/S9Pro-V2/S9Pro-V2-luotianyi.avif"
);
export const mouseS9UltraV2Luotianyi = sharedAssetUrl(
  "mouse/S9Ultra-V2/S9Ultra-V2-luotianyi.avif"
);
export const mouseX23ZhuoyueWhite = sharedAssetUrl(
  "mouse/X23Zhuoyue/X23Zhuoyue-white.avif"
);
export const mouseX23ZhuoyueBerryRed = sharedAssetUrl(
  "mouse/X23Zhuoyue/X23Zhuoyue-berryred.avif"
);
export const mouseX23ZhuoyueLightBlue = sharedAssetUrl(
  "mouse/X23Zhuoyue/X23Zhuoyue-lightblue.avif"
);
export const mouseX23BerryRed = sharedAssetUrl("mouse/X23/X23-berryred.avif");
export const mouseX23MaxWhite = sharedAssetUrl(
  "mouse/X23Max/X23Max-white.avif"
);
export const mouseX23MaxBerryRed = sharedAssetUrl(
  "mouse/X23Max/X23Max-berryred.avif"
);
export const mouseX23SELightGreen = sharedAssetUrl(
  "mouse/X23SE/X23SE-lightgreen.avif"
);
export const mouseX23SEPink = sharedAssetUrl("mouse/X23SE/X23SE-pink.avif");
export const mouseX23SEWhite = sharedAssetUrl("mouse/X23SE/X23SE-white.avif");
export const mouseX23SEBlack = sharedAssetUrl("mouse/X23SE/X23SE-black.avif");
export const mouseX23SEBerryRed = sharedAssetUrl(
  "mouse/X23SE/X23SE-berryred.avif"
);
export const mouseS9V2MasterMambagreen = sharedAssetUrl(
  "mouse/S9V2Master/S9V2Master-mambagreen.avif"
);
export const mouseS9V2MasterPlusBlack = sharedAssetUrl(
  "mouse/S9V2Master+/s9v2master+-black.avif"
);
export const mouseS9V2MasterPlusPurple = sharedAssetUrl(
  "mouse/S9V2Master+/s9v2master+-purple.avif"
);
export const mouseS9V2MasterPlusSilver = sharedAssetUrl(
  "mouse/S9V2Master+/s9v2master+-silver.avif"
);
export const mouseS9V2MasterPlusRed = sharedAssetUrl(
  "mouse/S9V2Master+/s9v2master+-red.avif"
);
export const mouseS9V2UltimateLightblue = sharedAssetUrl(
  "mouse/S9V2Ultimate/S9V2Ultimate-lightblue.avif"
);
export const mouseS9V2UltimateRed = sharedAssetUrl(
  "mouse/S9V2Ultimate/S9V2Ultimate-red.avif"
);
export const mouseS9V2UltimateSilver = sharedAssetUrl(
  "mouse/S9V2Ultimate/S9V2Ultimate-silver.avif"
);
// S9 Max / S9 Ultra（贝盈方案）新增素材
export const mouseS9MaxCyan = sharedAssetUrl("mouse/S9Max/S9Max-cyan.avif");
export const mouseS9UltraWhite = sharedAssetUrl(
  "mouse/S9Ultra/S9Ultra-white.avif"
);
export const mouseS9UltraRed = sharedAssetUrl("mouse/S9Ultra/S9Ultra-red.avif");
export const mouseS9UltraBlack = sharedAssetUrl(
  "mouse/S9Ultra/S9Ultra-black.avif"
);
export const mouseS9UltraBlackpurple = sharedAssetUrl(
  "mouse/S9Ultra/S9Ultra-blackpurple.avif"
);
export const mouseS9UltraSilver = sharedAssetUrl(
  "mouse/S9Ultra/S9Ultra-silver.avif"
);
// S9 Pro（贝盈方案）新增素材
export const mouseS9ProBlack = sharedAssetUrl("mouse/S9Pro/S9Pro-black.avif");
export const mouseS9ProWhite = sharedAssetUrl("mouse/S9Pro/S9Pro-white.avif");
export const mouseS9ProRed = sharedAssetUrl("mouse/S9Pro/S9Pro-red.avif");
export const mouseS9ProSilver = sharedAssetUrl("mouse/S9Pro/S9Pro-silver.avif");
export const mouseS9ProBlackpurple = sharedAssetUrl(
  "mouse/S9Pro/S9Pro-blackpurple.avif"
);
export const sensorRotationDialLight = sharedAssetUrl(
  "mouse/rotatedial-light.svg"
);
export const sensorRotationDialDark = sharedAssetUrl(
  "mouse/rotatedial-dark.svg"
);
export const sensorRotationMouseLight = sharedAssetUrl(
  "mouse/rotatemouse-light.svg"
);
export const sensorRotationMouseDark = sharedAssetUrl(
  "mouse/rotatemouse-dark.svg"
);
export const sensorRotationScaleLight = sharedAssetUrl(
  "mouse/rotatescale-light.svg"
);
export const sensorRotationScaleDark = sharedAssetUrl(
  "mouse/rotatescale-dark.svg"
);
export const batteryLifeMouseLight = sharedAssetUrl(
  "mouse/performancePage/mouse-light.svg"
);
export const batteryLifeMouseDark = sharedAssetUrl(
  "mouse/performancePage/mouse-dark.svg"
);
// 触发设置 — 按键校准叠图
export const mouseCalBaseLight = sharedAssetUrl(
  "mouse/mousetest/mousejiaozhun-light.svg"
);
export const mouseCalBaseDark = sharedAssetUrl(
  "mouse/mousetest/mousejiaozhun-dark.svg"
);
export const mouseCalLeftHighlight = sharedAssetUrl(
  "mouse/mousetest/mouseleft.svg"
);
export const mouseCalRightHighlight = sharedAssetUrl(
  "mouse/mousetest/mouseright.svg"
);
export const mouseCalLeftHighlight2 = sharedAssetUrl(
  "mouse/mousetest/mouseleft2.svg"
);
export const mouseCalRightHighlight2 = sharedAssetUrl(
  "mouse/mousetest/mouseright2.svg"
);
// S9 （展立方案）新增素材
export const mouseS9White = sharedAssetUrl("mouse/S9/S9-white.avif");
export const mouseS9Black = sharedAssetUrl("mouse/S9/S9-black.avif");
// S9 SE（富瑞方案）
export const mouseS9SEWhite = sharedAssetUrl("mouse/S9SE/S9SE-white.avif");
export const mouseS9SEBlack = sharedAssetUrl("mouse/S9SE/S9SE-black.avif");
// X23 pro （远大芯方案）新增素材
export const mouseX23ProWhite = sharedAssetUrl(
  "mouse/X23Pro/X23Pro-white.avif"
);
export const mouseX23ProBlack = sharedAssetUrl(
  "mouse/X23Pro/X23Pro-black.avif"
);
export const mouseX23ProBlue = sharedAssetUrl("mouse/X23Pro/X23Pro-blue.avif");
export const mouseX23ProJiangGuoHong = sharedAssetUrl(
  "mouse/X23Pro/X23Pro-jiangguohong.avif"
);
export const mouseX23ProShuMeiPink = sharedAssetUrl(
  "mouse/X23Pro/X23Pro-shumeipink.avif"
);
export const mousex23ProCyberPanda = sharedAssetUrl(
  "mouse/X23Pro/X23Pro-saiboxiongmao.avif"
);
// S7 Pro （贝盈方案）
export const mouseS7ProWhite = sharedAssetUrl("mouse/S7Pro/S7Pro-white.avif");
// S7 Plus（富芮坤 C 方案）
export const mouseS7PlusWhite = sharedAssetUrl(
  "mouse/S7Plus/S7Plus-white.avif"
);
export const mouseS7PlusBlack = sharedAssetUrl(
  "mouse/S7Plus/S7Plus-black.avif"
);
// S2（富芮坤 C 方案）
export const mouseS2White = sharedAssetUrl("mouse/S2/S2-white.avif");
export const mouseS2Black = sharedAssetUrl("mouse/S2/S2-black.avif");
export const mouseS2Blue = sharedAssetUrl("mouse/S2/S2-blue.avif");
export const mouseS2BerryRed = sharedAssetUrl("mouse/S2/S2-berryred.avif");
export const mouseS2Green = sharedAssetUrl("mouse/S2/S2-green.avif");
// S7（富芮坤方案）
export const mouseS7White = sharedAssetUrl("mouse/S7/S7-white.avif");
export const mouseS7BerryRed = sharedAssetUrl("mouse/S7/S7-berryRed.avif");
export const mouseS7Green = sharedAssetUrl("mouse/S7/S7-green.avif");
// S7 SE（富芮坤方案）
export const mouseS7seWhite = sharedAssetUrl("mouse/S7se/S7se-white.avif");
export const mouseS7seBerryRed = sharedAssetUrl(
  "mouse/S7se/S7se-berryRed.avif"
);
export const mouseS7seGreen = sharedAssetUrl("mouse/S7se/S7se-green.avif");
// S7 Max（贝盈方案）
export const mouseS7MaxWhite = sharedAssetUrl("mouse/S7Max/S7Max-white.avif");
export const mouseS7MaxBlackGold = sharedAssetUrl(
  "mouse/S7Max/S7Max-blackgold.avif"
);
export const mouseS7MaxJiangGuoHong = sharedAssetUrl(
  "mouse/S7Max/S7Max-jiangguohong.avif"
);
// S7 Ultra（贝盈方案）
export const mouseS7UltraWhite = sharedAssetUrl(
  "mouse/S7Ultra/S7Ultra-white.avif"
);
export const mouseS7UltraBlackGold = sharedAssetUrl(
  "mouse/S7Ultra/S7Ultra-blackgold.avif"
);
export const mouseS7UltraJiangGuoHong = sharedAssetUrl(
  "mouse/S7Ultra/S7Ultra-jiangguohong.avif"
);
// X23碳纤维（富芮坤方案）
export const mouseX23CarbonBlack = sharedAssetUrl(
  "mouse/X23Carbon/X23Carbon-black.avif"
);
export const mouseX23CarbonQianlan = sharedAssetUrl(
  "mouse/X23Carbon/X23Carbon-qianlan.avif"
);
export const mouseX23CarbonSilver = sharedAssetUrl(
  "mouse/X23Carbon/X23Carbon-silver.avif"
);
// X23L碳纤维（富芮坤方案）
export const mouseX23LCarbonBlack = sharedAssetUrl(
  "mouse/X23LCarbon/X23LCarbon-black.avif"
);
export const mouseX23LCarbonSilver = sharedAssetUrl(
  "mouse/X23LCarbon/X23LCarbon-silver.avif"
);
// A6（富芮坤方案）
export const mouseA6XiangYaWhite = sharedAssetUrl(
  "mouse/A6/A6-xiangyawhite.avif"
);
// A6 Pro（富芮坤方案）
export const mouseA6ProXiangYaWhite = sharedAssetUrl(
  "mouse/A6Pro/A6Pro-xiangyawhite.avif"
);
export const mouseA6ProBingChuanBlue = sharedAssetUrl(
  "mouse/A6Pro/A6Pro-bingchuanblue.avif"
);
export const mouseA6ProJingdianBlack = sharedAssetUrl(
  "mouse/A6Pro/A6Pro-jingdianblack.avif"
);
export const mouseA6ProYingHuaPink = sharedAssetUrl(
  "mouse/A6Pro/A6Pro-yinghuapink.avif"
);
// A6 Max（富芮坤方案）
export const mouseA6MaxXiangYaWhite = sharedAssetUrl(
  "mouse/A6Max/A6Max-xiangyawhite.avif"
);
// G2SE A
export const mouseG2SEAWhite = sharedAssetUrl("mouse/G2SEA/G2SEA-white.avif");
export const mouseG2SEABlack = sharedAssetUrl("mouse/G2SEA/G2SEA-black.avif");
// A7 SE（富芮坤方案）
export const mouseA7SEWhite = sharedAssetUrl("mouse/A7SE/A7SE-white.avif");
// A7（富芮坤方案）
export const mouseA7White = sharedAssetUrl("mouse/A7/A7-white.avif");
export const mouseA7Black = sharedAssetUrl("mouse/A7/A7-black.avif");
// A7 Pro（富芮坤方案）
export const mouseA7ProWhite = sharedAssetUrl("mouse/A7Pro/A7Pro-white.avif");
export const mouseA7ProBlack = sharedAssetUrl("mouse/A7Pro/A7Pro-black.avif");
// Alpha7（展立方案）
export const mouseAlpha7White = sharedAssetUrl(
  "mouse/Alpha7/Alpha7-white.avif"
);
export const mouseAlpha7Black = sharedAssetUrl(
  "mouse/Alpha7/Alpha7-black.avif"
);
export const mouseAlpha7Pink = sharedAssetUrl("mouse/Alpha7/Alpha7-pink.avif");
// Alpha6（匠盟方案 / EXX）
export const mouseAlpha6Blackwhite = sharedAssetUrl(
  "mouse/Alpha6/Alpha6-blackwhite.avif"
);
export const mouseAlpha6Blackorange = sharedAssetUrl(
  "mouse/Alpha6/Alpha6-blackorange.avif"
);
export const mouseAlpha6Berryred = sharedAssetUrl(
  "mouse/Alpha6/Alpha6-berryred.avif"
);
// Z7 Max（展立方案）
export const mouseZ7MaxBlack = sharedAssetUrl("mouse/Z7Max/Z7Max-black.avif");
// E7（富芮坤方案）
export const mouseE7Black = sharedAssetUrl("mouse/E7/E7-black.avif");
export const mouseE7White = sharedAssetUrl("mouse/E7/E7-white.avif");
export const mouseE7BerryRed = sharedAssetUrl("mouse/E7/E7-berryred.avif");
export const mouseE7LemonGreen = sharedAssetUrl("mouse/E7/E7-lemongreen.avif");
export const mouseE7SkyBlue = sharedAssetUrl("mouse/E7/E7-skyblue.avif");
export const mouseE7FireRed = sharedAssetUrl("mouse/E7/E7-firered.avif");
export const mouseE7Foggywhite = sharedAssetUrl("mouse/E7/e7-Foggywhite.avif");
// E9（富芮坤方案）
export const mouseE9Black = sharedAssetUrl("mouse/E9/E9-black.avif");
export const mouseE9White = sharedAssetUrl("mouse/E9/E9-white.avif");
export const mouseE9BerryRed = sharedAssetUrl("mouse/E9/E9-berryred.avif");
export const mouseE9LemonGreen = sharedAssetUrl("mouse/E9/E9-lemongreen.avif");
// E9 Carbon / E9 Pro Carbon（共用配色图）
export const mouseE9CarbonBlack = sharedAssetUrl(
  "mouse/E9Carbon/E9Carbon-black.avif"
);
export const mouseE9CarbonWhite = sharedAssetUrl(
  "mouse/E9Carbon/E9Carbon-white.avif"
);
export const mouseE9CarbonBerryRed = sharedAssetUrl(
  "mouse/E9Carbon/E9Carbon-berryred.avif"
);
// E11 / E11 Pro（富芮坤方案，共用配色图）
export const mouseE11White = sharedAssetUrl("mouse/E11/E11-white.avif");
export const mouseE11BerryRed = sharedAssetUrl("mouse/E11/E11-berryred.avif");
export const mouseE11SakuraPink = sharedAssetUrl(
  "mouse/E11/E11-sakurapink.avif"
);
// A8 WB Ultra（匠盟方案）
export const mouseA8Panda = sharedAssetUrl("mouse/A8WBUltra/A8-panda.avif");
export const mouseA8BerryRed = sharedAssetUrl(
  "mouse/A8WBUltra/A8-berryred.avif"
);
// 匠盟传感器模式使用 *mode 结尾图片
export const officeModeImg = sharedAssetUrl(
  "mouse/performancePage/officemode.avif"
);
export const esportModeImg = sharedAssetUrl(
  "mouse/performancePage/esportmode.avif"
);
export const berserkModeImg = sharedAssetUrl(
  "mouse/performancePage/berserkmode.avif"
);
// 贝盈工作模式使用不带 mode 的图片
export const officeWorkModeImg = sharedAssetUrl(
  "mouse/performancePage/office.avif"
);
export const highspeedWorkModeImg = sharedAssetUrl(
  "mouse/performancePage/highspeed.avif"
);
export const esportWorkModeImg = sharedAssetUrl(
  "mouse/performancePage/esport.avif"
);
export const berserkWorkModeImg = sharedAssetUrl(
  "mouse/performancePage/berserk.avif"
);
// Export common assets
export const keyboardImg = sharedAssetUrl("common/keyboard.svg");
export const mouseImg = sharedAssetUrl("common/mouse.svg");
export const typecImg = sharedAssetUrl("common/typec.svg");
export const cloudImg = sharedAssetUrl("common/cloud.svg");
export const avatar = sharedAssetUrl("common/avatar.png");
export const avatar2 = sharedAssetUrl("common/avatar2.png");
export const unlogin = sharedAssetUrl("common/unlogin.png");
export const feedbackImg = sharedAssetUrl("common/feedback.svg");
export const toastImg = sharedAssetUrl("common/toast.svg");
export const speakerImg = sharedAssetUrl("common/speaker.png");
export const comunidadImg = sharedAssetUrl("common/comunidad.png");
export const auraSyncImg = sharedAssetUrl("common/auraSync.png");
export const charge25Img = sharedAssetUrl("common/charge25.svg");
export const charge50Img = sharedAssetUrl("common/charge50.svg");
export const charge75Img = sharedAssetUrl("common/charge75.svg");
export const charge100Img = sharedAssetUrl("common/charge100.svg");
export const menu001 = sharedAssetUrl("menu/001.png");
// es68
export const keyboardEs68Black = sharedAssetUrl(
  "keyboard/es68/es68-black.avif"
);
export const keyboardEs68White = sharedAssetUrl(
  "keyboard/es68/es68-white.avif"
);
export const keyboardEs68Pink = sharedAssetUrl("keyboard/es68/es68-pink.avif");
export const keyboardEs68Luotianyi = sharedAssetUrl(
  "keyboard/es68/es68-luotianyi.avif"
);
// DEEP68
export const keyboardDeep68White = sharedAssetUrl("keyboard/deep68/white.avif");
export const keyboardDeep68Pink = sharedAssetUrl("keyboard/deep68/pink.avif");
// battle68 (EWEADN BAT68)
export const keyboardBattle68Black = sharedAssetUrl(
  "keyboard/battle68/battle68-black.avif"
);
export const keyboardBattle68Blackred = sharedAssetUrl(
  "keyboard/battle68/battle68-blackred.avif"
);
export const keyboardBattle68Blackyellow = sharedAssetUrl(
  "keyboard/battle68/battle68-blackyellow.avif"
);
export const keyboardBattle68Weichen = sharedAssetUrl(
  "keyboard/battle68/battle68-weichen.avif"
);
// Tank68 HE
export const keyboardTank68Black = sharedAssetUrl(
  "keyboard/Tank68/Tank68-black.avif"
);
export const keyboardTank68Blackredcontourline = sharedAssetUrl(
  "keyboard/Tank68/Tank68-blackredcontourline.avif"
);
export const keyboardTank68Blackcontourline = sharedAssetUrl(
  "keyboard/Tank68/Tank68-blackcontourline.avif"
);
export const keyboardTank68Whitecontourline = sharedAssetUrl(
  "keyboard/Tank68/Tank68-whitecontourline.avif"
);
// DEEP80 MAX
export const keyboardDeep80MaxWhite = sharedAssetUrl(
  "keyboard/deep80max/white.avif"
);
export const keyboardDeep80MaxBerryRed = sharedAssetUrl(
  "keyboard/deep80max/berryRed.avif"
);
export const keyboardDeep80MaxBerryRedTranslucent = sharedAssetUrl(
  "keyboard/deep80max/berryRed-translucent.avif"
);
// DEEP80 Pro
export const keyboardDeep80ProWhite = sharedAssetUrl(
  "keyboard/deep80pro/white.avif"
);
export const keyboardDeep80ProBerryRed = sharedAssetUrl(
  "keyboard/deep80pro/berryRed.avif"
);
export const keyboardDeep80ProBerryRedTranslucent = sharedAssetUrl(
  "keyboard/deep80pro/berryRed-translucent.avif"
);
// DK80
export const keyboardDk80White = sharedAssetUrl(
  "keyboard/dk80/dk80-white.avif"
);
export const keyboardDk80Whitepink = sharedAssetUrl(
  "keyboard/dk80/dk80-whitepink.avif"
);
export const keyboardDk80Zheying = sharedAssetUrl(
  "keyboard/dk80/dk80-zheying.avif"
);
export const keyboardDk80Denggaoxianwhite = sharedAssetUrl(
  "keyboard/dk80/dk80-denggaoxianwhite.avif"
);
export const keyboardDk80Russiawhite = sharedAssetUrl(
  "keyboard/dk80/dk80-russiawhite.avif"
);
export const keyboardDk80Weichen = sharedAssetUrl(
  "keyboard/dk80/dk80-weichen.avif"
);
export const keyboardDk80Russiaweichen = sharedAssetUrl(
  "keyboard/dk80/dk80-russiaweichen.avif"
);
// x87v2
export const keyboardx87v2Blackberry = sharedAssetUrl(
  "keyboard/x87v2/x87v2-blackberry.avif"
);
export const keyboardx87v2Cherryblossompink = sharedAssetUrl(
  "keyboard/x87v2/x87v2-cherryblossompink.avif"
);
export const keyboardx87v2Contourline = sharedAssetUrl(
  "keyboard/x87v2/x87v2-contourline.avif"
);
export const keyboardx87v2Dust = sharedAssetUrl(
  "keyboard/x87v2/x87v2-dust.avif"
);
export const keyboardx87v2Shadowfold = sharedAssetUrl(
  "keyboard/x87v2/x87v2-shadowfold.avif"
);
export const keyboardV80Default = sharedAssetUrl(
  "keyboard/v80/v80-default.png"
);
export const keyboardV102Default = sharedAssetUrl(
  "keyboard/v102/v102-default.png"
);
// X87S
export const keyboardX87sBlackpink = sharedAssetUrl(
  "keyboard/x87s/x87s-blackpink.avif"
);
export const keyboardX87sLuotianyi = sharedAssetUrl(
  "keyboard/x87s/x87s-luotianyi.avif"
);
export const keyboardX87sSakurapink = sharedAssetUrl(
  "keyboard/x87s/x87s-sakurapink.avif"
);
export const keyboardX87sWeichen = sharedAssetUrl(
  "keyboard/x87s/x87s-weichen.avif"
);
export const keyboardX87sWhitedenggaoxian = sharedAssetUrl(
  "keyboard/x87s/x87s-whitedenggaoxian.avif"
);
export const keyboardX87sZheying = sharedAssetUrl(
  "keyboard/x87s/x87s-zheying.avif"
);
// m80 1k
export const keyboardM80Blue = sharedAssetUrl("keyboard/m80/M80_blue.avif");
export const keyboardM80White = sharedAssetUrl("keyboard/m80/M80_white.avif");
// m71 1k（与 m80 相同走 DEVICE_CONFIGS + 配色图）
export const keyboardM71LipstickDot = sharedAssetUrl(
  "keyboard/m71/MUSE-M71-LipstickDot.avif"
);
export const keyboardM71CuteBearLiquidFoundation = sharedAssetUrl(
  "keyboard/m71/MUSE-M71-CuteBearLiquidFoundation.avif"
);
export const keyboardM71LipstickCuteLittleBear = sharedAssetUrl(
  "keyboard/m71/MUSE-M71-LipstickCuteLittleBear.avif"
);
export const keyboardM71LiquidFoundationDots = sharedAssetUrl(
  "keyboard/m71/MUSE-M71-LiquidFoundationDots.avif"
);
// GS02 Pro
export const mouseGS02ProJiYeBlack = sharedAssetUrl(
  "mouse/GS02Pro/GS02Pro-jiyeblack.avif"
);
export const mouseGS02ProYueGuangBai = sharedAssetUrl(
  "mouse/GS02Pro/GS02Pro-yueguangbai.avif"
);
// M98屏幕版
export const keyboardM98TFTJingTou = sharedAssetUrl(
  "keyboard/m98TFT/m98TFT-jingtou.avif"
);
// E7 V2
export const mouseE7V2Black = sharedAssetUrl("mouse/E7V2/E7V2-black.avif");
export const mouseE7V2White = sharedAssetUrl("mouse/E7V2/E7V2-white.avif");
// T87
export const keyboardT87JiGuangWhite = sharedAssetUrl(
  "keyboard/t87/t87-jiguangwhite.avif"
);
export const keyboardT87MoYunHui = sharedAssetUrl(
  "keyboard/t87/t87-moyunhui.avif"
);
export const keyboardT87NingYePink = sharedAssetUrl(
  "keyboard/t87/t87-ningyepink.avif"
);
export const keyboardT87TaoYueWhite = sharedAssetUrl(
  "keyboard/t87/t87-taoyuewhite.avif"
);
export const keyboardT87YunTianBlue = sharedAssetUrl(
  "keyboard/t87/t87-yuntianblue.avif"
);
// E7 Pro
export const mouseE7ProBlack = sharedAssetUrl("mouse/E7Pro/E7Pro-black.avif");
export const mouseE7ProWhite = sharedAssetUrl("mouse/E7Pro/E7Pro-white.avif");
export const mouseE7ProBerryRed = sharedAssetUrl(
  "mouse/E7Pro/E7Pro-berryred.avif"
);
// E7 V2 Max
export const mouseE7V2MaxBlack = sharedAssetUrl(
  "mouse/E7V2Max/E7V2Max-black.avif"
);
export const mouseE7V2MaxWhite = sharedAssetUrl(
  "mouse/E7V2Max/E7V2Max-white.avif"
);
export const mouseE7V2MaxBerryRed = sharedAssetUrl(
  "mouse/E7V2Max/E7V2Max-berryred.avif"
);
// G5
export const mouseG5JinShuBlack = sharedAssetUrl(
  "mouse/G5/G5-jinshublack.avif"
);
export const mouseG5KaiJiaRed = sharedAssetUrl("mouse/G5/G5-kaijiared.avif");
export const mouseG5XiangBinBlue = sharedAssetUrl(
  "mouse/G5/G5-xiangbinblue.avif"
);
// Earphone — HG50（占位图，正式产品图到位后替换）
export const earphoneHg50Default = sharedAssetUrl(
  "earphone/hg50/hg50-default.svg"
);
// Earphone — VX07 洛天依蓝
export const earphoneVx07LuotianyiBlue = sharedAssetUrl(
  "earphone/vx07/VX07-luotianyi-blue.avif"
);
// Earphone — VX01
export const earphoneVx01Black = sharedAssetUrl(
  "earphone/vx01/vx01-black.avif"
);
export const earphoneVx01White = sharedAssetUrl(
  "earphone/vx01/vx01-white.avif"
);
export const earphoneVx01BerryRed = sharedAssetUrl(
  "earphone/vx01/vx01-berryRred.avif"
);
// Earphone — VX01S
export const earphoneVx01sBlack = sharedAssetUrl(
  "earphone/vx01s/vx01S-black.avif"
);
export const earphoneVx01sWhitePink = sharedAssetUrl(
  "earphone/vx01s/vx01S-whitePink.avif"
);
export const earphoneVx01sBlackOrange = sharedAssetUrl(
  "earphone/vx01s/vx01S-blackOrange.avif"
);
// Earphone — VX02
export const earphoneVx02BlackRed = sharedAssetUrl(
  "earphone/vx02/VX02-blackRed.avif"
);
export const earphoneVx02WhiteBlue = sharedAssetUrl(
  "earphone/vx02/VX02-whiteBlue.avif"
);
// Earphone — VX20（图来自 old-hub-web）
export const earphoneVx20Default = sharedAssetUrl(
  "earphone/vx20/vx20-default.png"
);
export const earphoneVx20Pink = sharedAssetUrl("earphone/vx20/vx20-pink.png");
export const earphoneVx20Blue = sharedAssetUrl("earphone/vx20/vx20-blue.png");
// DK75 Pro
export const keyboardDk75ProMistyWhite = sharedAssetUrl(
  "keyboard/dk75pro/dk75pro-mistywhite.avif"
);
export const keyboardDk75ProMistyPurple = sharedAssetUrl(
  "keyboard/dk75pro/dk75pro-mistypurple.avif"
);
export const keyboardDk75ProLakeGreen = sharedAssetUrl(
  "keyboard/dk75pro/dk75pro-lakegreen.avif"
);
// DK75 E
export const keyboardDk75EWhite = sharedAssetUrl(
  "keyboard/dk75e/dk75e-white.avif"
);
// DK75
export const keyboardDk75MistyWhite = sharedAssetUrl(
  "keyboard/dk75/dk75-mistywhite.avif"
);
export const keyboardDk75MistyPurple = sharedAssetUrl(
  "keyboard/dk75/dk75-mistypurple.avif"
);
export const keyboardDk75MistyPink = sharedAssetUrl(
  "keyboard/dk75/dk75-mistypink.avif"
);
export const keyboardDk87BaiFenJianBian = sharedAssetUrl(
  "keyboard/dk87/dk87-baifenjianbian.avif"
);
export const keyboardDk87Black = sharedAssetUrl(
  "keyboard/dk87/dk87-black.avif"
);
export const keyboardDk87BlackPink = sharedAssetUrl(
  "keyboard/dk87/dk87-blackpink.avif"
);
export const keyboardDk87QingTi = sharedAssetUrl(
  "keyboard/dk87/dk87-qingti.avif"
);
export const keyboardDk87Weichen = sharedAssetUrl(
  "keyboard/dk87/dk87-weichen.avif"
);
export const keyboardDk87White = sharedAssetUrl(
  "keyboard/dk87/dk87-white.avif"
);
// DK108
export const keyboardDk108White = sharedAssetUrl(
  "keyboard/dk108/dk108-white.avif"
);
export const keyboardDk108Black = sharedAssetUrl(
  "keyboard/dk108/dk108-black.avif"
);
export const keyboardDk108BingDaoBlue = sharedAssetUrl(
  "keyboard/dk108/dk108-bingdaoblue.avif"
);
export const keyboardDk108BlackPink = sharedAssetUrl(
  "keyboard/dk108/dk108-blackpink.avif"
);
export const keyboardDk108QingTiGreen = sharedAssetUrl(
  "keyboard/dk108/dk108-qingtigreen.avif"
);
export const keyboardDk108TaoYaoPink = sharedAssetUrl(
  "keyboard/dk108/dk108-taoyaopink.avif"
);
export const keyboardDk108TianKongBlue = sharedAssetUrl(
  "keyboard/dk108/dk108-tiankongblue.avif"
);
export const keyboardDk108TianShuiBi = sharedAssetUrl(
  "keyboard/dk108/dk108-tianshuibi.avif"
);
export const keyboardDk108WeiChen = sharedAssetUrl(
  "keyboard/dk108/dk108-weichen.avif"
);
export const keyboardDk108XiangYuPurple = sharedAssetUrl(
  "keyboard/dk108/dk108-xiangyupurple.avif"
);
export const keyboardDk108YingHuaPink = sharedAssetUrl(
  "keyboard/dk108/dk108-yinghuapink.avif"
);
// ZAP 68
export const keyboardZAP68Black = sharedAssetUrl(
  "keyboard/zap68/zap68-black.avif"
);
export const keyboardZAP68BlackPink = sharedAssetUrl(
  "keyboard/zap68/zap68-blackpink.avif"
);
export const keyboardZAP68FoggyBlack = sharedAssetUrl(
  "keyboard/zap68/zap68-foggyblack.avif"
);
// X87 Neon
export const keyboardX87NeonMistyBlue = sharedAssetUrl(
  "keyboard/x87neon/x87neon-mistyblue.avif"
);
// E11 V2
export const mouseE11V2White = sharedAssetUrl("mouse/E11V2/E11V2-white.avif");
export const mouseE11V2BerryRed = sharedAssetUrl(
  "mouse/E11V2/E11V2-berryred.avif"
);
